<!-- Modal DETALLE -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold; text-align: center;" class="modal-title" id="exampleModalLabel">GASTO COD:[{{ codi_edit }}]</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
            </div>
            <div class="modal-body">
                <div class="titulos1" *ngIf="estadoElegido=='PAGADO'" style="text-align:center">
                    <p style="color:rgba(231, 59, 28, 0.842); font-weight: bold; text-align: center;">
                        Estado: "{{ estgas }}"
                    </p>     
                    <app-loading class="m-5" *ngIf="loading3"></app-loading>             
                    <button (click)="getPago()" type="button" class="btn btn-success btn" >
                         <i> +ver info pago</i>
                    </button>
                    <hr>
                    <p *ngIf="dataSourcePago && botonImprimeOp" class="tituloINFO"><b>O/P {{ datoOp }} </b> paga Gastos <b>COD [{{arraypago}}]</b></p>
                    <p *ngIf="mostrarnopago" class="tituloINFO">El gasto COD [{{codi_edit}}] no tiene Orden de Pago.</p>
                    <a type="button" (click)="nada()" target="_blank" routerLink="/print" class="btn btn-warning  btn-block" *ngIf="dataSourcePago && botonImprimeOp" routerLinkActive="router-link-active" mat-button>IMPRIMIR ORDEN DE PAGO [{{datoOp}}] </a>
                    <br>
                </div>
                <div class="titulos2">
                    <p style="color:rgba(50, 50, 51, 0.973); font-weight: bold;">Dni: "{{ dnigasto }}" </p>    
                    <p style="color:rgb(51, 51, 51); font-weight: bold;">Descripción: "{{ det_edit }}" </p>
                    <p style="font-style: italic; font-weight: bold;">TOTAL: {{ tot_edit | currency:'$' }}</p>
                </div>
            </div>
            <div class="modal-footer" class="col-lg-12">
                <div style="text-align: center;" id="modalesa">
                    <button data-dismiss="modal" (click)="enviarCodGasto()" routerLink="/verdetalles-jorge" type="button" class="btn btn-primary btn-block">VER DETALLADO</button>
                    <a  hidden [disabled]="userlog=='17594163'" *ngIf="(puedePagarTodo) && puedePagar && TOTAL_suma" (click)="prepararIndividual()" routerLinkActive="router-link-active" data-toggle="modal" data-target="#MODALPAGO" type="button" class="btn btn-success btn-block" mat-button>PAGAR GASTO [{{codi_edit}}] <h6 *ngIf="tot_edit">{{ tot_edit | currency:'$' }}</h6></a>
                    <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-info btn-block" mat-button (click)="imprimirGastos()">IMPRIMIR GASTO {{ codi_edit }}</a> &nbsp;
                    <!--
                   lanza el modal que ahora estoy lanzando para emitir pago en verdetalles-jorge
                    <button data-dismiss="modal" data-toggle="modal" data-target="#MODALPAGO" type="button" class="btn btn-success">EMITIR PAGO</button>
                -->
                </div>
                <hr>
                <div id="modalnga" style="text-align: center; height: 60px;">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                    <br>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Modal REPORTE -->
<div class="modal fade" id="MODALREPORTE" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">GENERAR REPORTE POR SECCIONAL</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" #REPORTE>
                <label *ngIf="loading==true" for="algo">Creando reporte de la SEC/DEL elegida:</label>
                <h5 *ngIf="!loading">{{ filtroSec }} - "{{ secdel }}"</h5>
                <app-loading class="m-5" *ngIf="loading"></app-loading>
            </div>
            <!--CIERRO DIV-->
            <div class="modal-footer" class="col-lg-12">
                <div style="text-align: center;" id="modalesa">
                    <button *ngIf="loading==false" data-dismiss="modal" type="button" (click)="exportAsExcelReporte()" class="btn btn-primary btn-block">GENERAR REPORTE</button>
                    <!--
                       lanza el modal que ahora estoy lanzando para emitir pago en verdetalles-jorge
                        <button data-dismiss="modal" data-toggle="modal" data-target="#MODALPAGO" type="button" class="btn btn-success">EMITIR PAGO</button>
                    -->
                </div>
                <hr>
                <div id="modalnga" style="text-align: center; height: 60px;">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                    <br>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- Modal PAGO -->
<div class="modal fade" id="MODALPAGO" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">ORDEN DE PAGO PARA LOS GASTOS [{{ str }}]</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="formGroupExampleInput">COD_GASTOS:</label>
                        <input type="text" class="form-control" name="codgas" id="codgas" value="{{str}}" readonly="readonly">
                    </div>
                    <div class="form-group">
                        <label for="formGroupExampleInput2">FECHA PAGO:</label>
                        <input type="text" class="form-control" name="fec_edit" id="fec_edit" value="{{fecha_hoy | date:'dd-MM-yyyy'}}" readonly="readonly">
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput3">SUMA: {{TOTAL_suma | currency:'$'}} - Fondo ({{fondo | currency:'$'}})</label>
                        <input type="text" class="form-control" name="importe" id="importe" value="{{(TOTAL_suma - fondo) | currency:'$'}}" readonly="readonly">
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput4">ORDEN PAGO NRO: (ultima fué: <b>{{ ultimoPago }}</b>)</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_PAGO" name="COD_PAGO" id="COD_PAGO" placeholder="ingresar manualmente del viejo sistema..">
                        <br>
                        <div *ngIf="errorpago==true" class="alert alert-danger" role="alert">
                            <h4 class="alert-heading">Error #OP001</h4>
                            <p>Se ingresó un número de Orden de Pago que se utilizó para otro destino..</p>
                            <p class="mb-0"></p>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput4">COD_OPERACION:</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_CHEQUE" name="COD_CHEQUE" id="COD_CHEQUE" placeholder="Ingresar manualmente del viejo sistema..">
                    </div>

                    <div class="form-group">
                        <label for="inputbanco">COD_BANCO:</label>
                        <select placeholder="Seleccione.." [(ngModel)]="COD_BANCO" name="COD_BANCO" id="COD_BANCO" class="form-control">
                            <option value="111400">111-400 "BANCO NACION CTA. CTE."</option>
                            <option value="111401" >111-401 "BANCO NACION TRANSFERENCIA"</option>
                            <option value="111402" >111-402 "BANCO ITAU TRANSFERENCIA"</option>
                            <option value="111403" >111-403 "BANCO ITAU CTA. CTE."</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="inputconcepto">COD_CONCEPTO:</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_CONCEPTO" name="COD_CONCEPTO" id="COD_CONCEPTO" placeholder="no es necesario.. dejar vacio..">
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <a *ngIf="error==false && errorpago==false" data-dismiss="modal" (click)="pagaTodo(); llamarNuevaTab();" type="button" class="btn btn-success">FINALIZAR PAGO</a>
                <a hidden id="botonNewTab" type="button" target="_blank" routerLink="/print" class="btn btn-success btn-block" mat-button>boton simula</a>
            </div>
        </div>
    </div>
</div>


<!-- FORMULARIO  -->
<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">

        <app-loading class="m-5" *ngIf="loading"></app-loading>

        <br>
        <span id="titlee" style="font-weight: bolder;"> Listado de Gastos  
            <span class="badge badge-pill badge-info">
                {{ noti }}  Gastos pendientes.. 
            </span>
        <span>
                <button id="botonactualiza" mat-icon-button color="black"
                    (click)="llenarNoti(); calculaSeccionales();"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Actualizar..">
                    <mat-icon aria-label="Volver">swap_horizontal_circle</mat-icon>
                </button>
            </span>
        <span *ngIf="(filtroSec != 'TODAS_LAS_SECCIONALES') && (filtroSec != null)">
                <button mat-icon-button color="black"
                    (click)="cargarGridReporte()"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Generar Reporte de gastos de {{filtroSec}}..">
                    <mat-icon aria-label="REPORTE POR SECCIONAL COMPLETO">attach_file</mat-icon>
                </button>
            </span>
        <span *ngIf="(filtroSec == 'TODAS_LAS_SECCIONALES')">
                <button mat-icon-button color="black"
                    (click)="cargarGridReporteTodas()"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Generar Reporte de gastos de {{filtroSec}}..">
                    <mat-icon aria-label="REPORTE POR SECCIONAL COMPLETO">attach_file</mat-icon>
                </button>
            </span>
        <span>
                <div class="btn-group">
                    <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Ver ultimos ({{dataSourceUltimos.length}}) recibidos..
                    </button>
                    <div class="dropdown-menu">
                        <h6 style="background-color: #AFD1EA" *ngFor="let gas of dataSourceUltimos">#{{gas.SEC_DEL}}-{{ gas.USUARIO }} "<b>{{ gas.COD_GASTO }}</b>"--> <b *ngIf="gas.ESTADOGASTO == 'PAGADO'" style="color: blue">{{ gas.ESTADOGASTO}}</b> <b *ngIf="gas.ESTADOGASTO == 'AUTORIZADO'" style="color: red">{{ gas.ESTADOGASTO}}</b> </h6>
                    </div>
                </div>
            </span>
        <span>
            &nbsp;
            <mat-radio-group aria-label="Estado" [(ngModel)]="estadoElegido">
                <mat-radio-button (click)="blanquearTodo();" value="AUTORIZADO">PENDIENTES</mat-radio-button>
                &nbsp;
                <mat-radio-button (click)="blanquearTodo()" value="PAGADO">PAGADOS</mat-radio-button>
            </mat-radio-group>
            </span>
        </span>
        <button hidden id="lmr" data-toggle="modal" data-target="#MODALREPORTE">botonlanza</button>
        <hr>
        <!--
      <div class="form-group">
          <label for="inputcategoria">CATEGORÍA</label>
          <select placeholder="Seleccione.." [(ngModel)]="CATEGORIA" name="CATEGORIA" id="CATEGORIA" class="form-control">
            <option>VIAJE</option>
            <option>SECCIONAL</option>
            <option>OTROS</option>
          </select>
      </div>
      -->
        <div class="form-group">
            <label for="inputsec">Seccional/Deleg</label>
            <select (click)="calculaUsuarios()" [(ngModel)]="filtroSec" name="filtroSec" id="filtroSec" class="form-control">
                <option value="TODAS_LAS_SECCIONALES">TODAS_LAS_SECCIONALES</option>
                <option *ngFor="let sec of dataSourceSeccionales.data" [ngValue]="sec.IDSEC">{{ sec.SECDEL }} - FONDO DISPONIBLE: {{ sec.FONDO | currency:"$"}}</option>
            </select>

            <label for="inputfiltroSec">Motivo</label>
            <select (click)="calculaUsuarios()" placeholder="Seleccione.." [(ngModel)]="filtroMotivo" name="filtroMotivo" id="filtroMotivo" class="form-control">
                <option>TODOS_LOS_MOTIVOS</option>
                <option>VIAJE</option>
                <option>GASTOS DELEGACION</option>
                <option>SECCIONAL</option>
          </select>

            <label for="inputfiltroSec">Listado de Usuarios con gastos pendientes de Pago</label>
            <app-loading class="m-5" *ngIf="loadingUsers"></app-loading>
            <select (click)="blanquearGrid()" placeholder="Seleccione.." [(ngModel)]="USER" name="USER" id="USER" class="form-control">
                <option *ngIf="contUsuariosCargados != 0" value="TODOS_LOS_USUARIOS">*************** SELECCIONAR TODOS_LOS_USUARIOS **************</option>
                <option *ngFor="let user of dataSource2.data" [ngValue]="user.ID">"{{ user.USUARIO }}", [{{ user.CANT }}] GASTOS DE "{{user.MOTIVO}}", TOTAL {{ user.TOTAL_PAGAR | currency:"$" }} </option>
                
          </select>

        </div>
        <!--
      <div class="form-group">
          <label for="inputcategoria">ESTADO</label>
          <select placeholder="Seleccione.." [(ngModel)]="EST" name="EST" id="EST" class="form-control">
            <option>PENDIENTE</option>
            <option>AUTORIZADO</option>
            <option>RECHAZADO</option>
          </select>
      </div>
      -->
        <button [disabled]="(haygastos==false) && (!USER)" data-dismiss="modal" (click)="cargarGrid()" type="button" class="btn btn-block btn-info">CONSULTAR</button>

        <div class="col-lg-12" id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>
                    <ng-container matColumnDef="COD_GASTO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_GASTO </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_GASTO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="USER">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                        <td mat-cell *matCellDef="let element"> {{element.USER}} </td>
                    </ng-container>
                    <ng-container hidden matColumnDef="DNI">
                        <th hidden mat-header-cell *matHeaderCellDef mat-sort-header> DNI </th>
                        <td hidden mat-cell *matCellDef="let element"> {{element.DNI}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_CARGA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_CARGA </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_CARGA | date:'dd-MM-yyyy' }} </td>
                    </ng-container>
                    <ng-container matColumnDef="MOTIVO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> MOTIVO </th>
                        <td mat-cell *matCellDef="let element"> {{element.MOTIVO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element"> {{element.DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TOTAL ($) </th>
                        <td style="font-weight: bold" mat-cell *matCellDef="let element"> {{ element.IMPORTE | currency:"$" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="ESTADO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTADO </th>
                        <td mat-cell *matCellDef="let element"> {{element.ESTADO}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.COD_GASTO,row.DETALLE,row.IMPORTE,row.FECHA_CARGA,row.ESTADO,row.DNI)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row); controlBotonPagar();"></tr>
                </table>
            </div>
            <tr>
                <button mat-icon-button color="accent" (click)="limpiarSeleccion()" data-toggle="tooltip" data-placement="right" title="Borrar los checks!">
                    <mat-icon aria-label="checks">delete</mat-icon>
                </button>
            </tr>
            <mat-paginator [pageSize]=15 [pageSizeOptions]="[5, 10, 25, 100, 200]"></mat-paginator>
        </div>
    </div>
    <!--
  <button class="btn-block" color="dark" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
  -->
    <a [disabled]="userlog=='17594163'" *ngIf="(puedePagarTodo) && puedePagar && TOTAL_suma" (click)="prepararMultiples()" routerLinkActive="router-link-active" data-toggle="modal" data-target="#MODALPAGO" type="button" class="btn btn-success btn-block" mat-button>PAGAR {{contselec}} GASTOS SELECCIONADOS! <h6 *ngIf="TOTAL_suma">[{{TOTAL_suma | currency:'$'}}]</h6></a>
    <button type="button" class="btn btn-secondary btn-block" mat-button routerLink="/home">Volver</button>

</div>